import { mapGetters, mapActions } from 'vuex';
import { resolveClickCta } from '@/common/utilities/nojq/_utilities.js';
import { versions } from '../../../common/utilities/nojq/_browser.js';
export default {
    name: 'dppHotleadButton',
    inject: ['$eventBus', 'split'],
    props: {
        assignedAgent: Object,
        theme: {
            type: String,
            default: '',
        },
        requestTourSubtext: {
            type: String,
            default: null,
        },
        messageAgentSubtext: {
            type: String,
            default: null,
        },
        requestVerticallLayout: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {};
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getDigsSubscribe', 'getSplit']),
        ...mapGetters('dpp', ['dpp', 'getHotleadLabel2', 'isDigsSubscribed']),
        isLargerSubtext() {
            return ['on9', 'on10', 'on11', 'on12', 'on13', 'on14', 'on15', 'on16'].includes(this.glb.splits['movoto-dpp-cta-button-CW-4438']) && this.requestTourSubtext;
        },
        oversizeContent() {
            return ['on9'].includes(this.glb.splits['movoto-dpp-cta-button-CW-4438']);
        },
        hasOJOAgent() {
            return this.glb.agent.id && !this.glb.rentals;
        },
        getAgentImageUrl() {
            return (this.hasOJOAgent && this.glb.agent.profilePhotoUrl) || '';
        },
        isSoldAndPr() {
            return this.dpp.isPrOnly || !this.dpp.listingId || this.dpp.isSold;
        },
        getCTALabel() {
            return this.molang(this.getHotleadLabel2);
        },
        getAssignedAgentLabel() {
            return this.assignedAgent && this.assignedAgent.firstName ? `Message ${this.assignedAgent.firstName}` : this.molang('dpp.hotButton.manageAssignedAgent');
        },
        hasTxtMsgForAgent() {
            return this.glb.isPhone && this.assignedAgent && this.assignedAgent.firstName && this.assignedAgent.phoneNumber && (this.glb.user.fullName || this.glb.user.email);
        },
        showCashOffer() {
            let isCashOfferCity =
                this.dpp.geo.cityPath &&
                ['tampa-fl', 'orlando-fl', 'denver-co', 'san-antonio-tx', 'jacksonville-fl', 'phoenix-az', 'portland-or', 'seattle-wa', 'houston-tx', 'tucson-az'].includes(
                    this.dpp.geo.cityPath.replace('/', '')
                );
            return this.getSplit('movoto-CW-819') && isCashOfferCity;
        },
        secondaryCtaTxt() {
            return this.molang('dpp.hotButton.msgAgent');
        },
        newSoldPublicRecordCta(){
            return this.getSplit('movoto-new-sold-pr-cta-CW-3566');
        },
        preApprovalButtonObj() {
            if (this.getSplit('movoto-cta-move-CW-3672')) {
                let cta = 'Get Pre-approved';
                if (this.getSplit('movoto-cta-move-CW-3672', 'on2')) {
                    cta = 'Get Pre-qualified';
                }
                return {
                    cta: cta,
                    utmcta: 'hotlead_btn',
                };
            }
            return null;
        },
    },

    methods: {
        ...mapActions('glb', ['addDigsSubscribe', 'favoriteListings', 'activateMovotoHomeLoansDripCampaign']),
        ...mapGetters('glb', ['getComplianceMethod']),
        openDig() {
            this.$eventBus.$emit('eventbus-pop-dig');
        },
        async showForm(preApprovalButtonObj) {
            if (!preApprovalButtonObj) {
                console.error('Invalid preApprovalButtonObj provided to showForm');
                return;
            }
            this.show3rdPartyForm(preApprovalButtonObj.utmcta, preApprovalButtonObj.url, preApprovalButtonObj.cta);
        },
        show3rdPartyForm(id, url, cta, isAppendUtmCta = false, evt) {
            const resolvedCta = resolveClickCta(cta, evt, 'BTN');
            this.$eventBus.$emit('eventbus-pop-3rdparty', {
                id: id,
                url: url,
                zipcode: this.dpp.geo.zipcode,
                price: this.dpp.price,
                propertyType: this.dpp.propertyType,
                propertyId: this.dpp.propertyId,
                houseRealStatus: this.dpp.houseRealStatus,
                trigger: this.$options.name,
                cta: resolvedCta,
                imageUrl: this.dpp.tnImgPath,
                listingUrl: (this.dpp.path && `${this.glb.appUrl}${this.dpp.path}`) || '',
                isAppendUtmCta: isAppendUtmCta,
            });
        },
        sendMessage() {
            var consumerFirstName = this.glb.user.fullName ? this.glb.user.fullName.split(' ')[0] : this.glb.user.email.split('@')[0];
            var smsChar = versions().ios ? '&' : '?';
            var smsBody = `Hi ${this.assignedAgent.firstName}. Its ${consumerFirstName}. I am interested in ${this.glb.geo.formatAddress}. Would you be able to set up a showing? ${this.dpp.dppUrl}`;
            try {
                console.log(`sms:${this.assignedAgent.phoneNumber}${smsChar}body=${encodeURIComponent(smsBody)}`);
                window.location.href = `sms:${this.assignedAgent.phoneNumber}${smsChar}body=${encodeURIComponent(smsBody)}`;
            } catch (err) {
                console.log(err);
            }
        },
        openCashOffer() {
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtCashOffer',
                trigger: this.$options.name,
                opt: {
                    propertyData: this.dpp,
                    hotleadType: 'CashOfferPrimaryInactiveCTA',
                    buttonText: this.molang('dpp.hotleadForm.go'),
                    showAddress: false,
                },
            });
        },
        showBuyerAgentCTA() {
            const compliance = this.getComplianceMethod()();
            let compRule = compliance[0] && compliance[0].rule;
            return compRule && compRule.indexOf('showBuyerAgentCTA') >= 0;
        },
        openInActiveSellLead() {
            let buttonText = this.newSoldPublicRecordCta ? this.molang('dpp.hotleadForm.submit') : this.molang('dpp.hotButton.msgAgent');
            this.hasOJOAgent ? this.openAssignedAgentHotlead(buttonText) : this.openHotlead(buttonText);
        },
        openHotlead(buttonText) {
            //set diff hotleadtype when the css force the hotlead floating
            const body = window?.document?.getElementById('body');
            let isFloating = false;
            if (body && body.classList && body.classList.contains('scrollDown') && !body.classList.contains('overlay-active') && body.clientWidth < 992) {
                isFloating = true;
            }
            let hotleadType = isFloating ? 'PrimaryMessageAgent_Floating' : 'GoSeeThisHomeHotleadInResponsiveDPP';
            const listingAgentData = this.dpp.listingByMovoto && this.dpp.listingAgentData;
            let showCommentBox = false;
            let subCopy = '';
            let hideProfile = false;
            let hotleadTitle;
            let hotleadSub;
            if (!this.dpp.isActive) {
                hotleadType = this.newSoldPublicRecordCta ? 'RequestSellingConsultation_SoldPRDPP' : 'OffMarketCombinationSell';
                hotleadSub = 'Talk to a top local agent about selling your home today. No obligation.';
                if (buttonText == this.molang('dpp.hotButton.msgAgent')) {
                    hotleadTitle = 'Message an Agent About Selling';
                }
                hotleadTitle = this.newSoldPublicRecordCta && 'Schedule a selling consultation';
            } else if (buttonText == this.molang('dpp.hotButton.msgAgent') || buttonText == this.molang('dpp.hotButton.askAgent')) {
                hotleadTitle = buttonText;
                if (this.showBuyerAgentCTA()) {
                    hotleadTitle = this.molang('dpp.hotleadForm.msgOjoAgent');
                }
                var deviceType = this.glb.isMobile ? 'Mobile' : '';
                if (this.dpp.houseRealStatus === 'ACTIVE' || this.dpp.houseRealStatus === 'PENDING') {
                    if (deviceType) {
                        hotleadType = isFloating ? 'PrimaryMessageAgent_Floating' : '_FixedHotleadInResponsiveDPPMobile';
                    } else {
                        hotleadType = isFloating ? 'PrimaryMessageAgent_Floating' : 'FixedHotleadInResponsiveDPP';
                    }
                } else if (this.dpp.houseRealStatus === 'SOLD') {
                    hotleadType = isFloating ? 'PrimaryMessageAgent_Floating' : '_FixedHotleadInResponsiveSoldDPP' + deviceType;
                } else if (this.dpp.houseRealStatus === 'OFF_MARKET') {
                    hotleadType = isFloating ? 'PrimaryMessageAgent_Floating' : '_FixedHotleadInResponsivePrDPP' + deviceType;
                }
                subCopy =
                    this.dpp.houseRealStatus === 'ACTIVE' || this.dpp.houseRealStatus === 'PENDING'
                        ? this.molang('dpp.hotButton.messageAgentLeadSupport')
                        : '';
                this.$eventBus.$emit('ga', {
                    ec: 'dppHotleadButton',
                    en: 'click_custom',
                    el: 'Message_Agent',
                    props: { link_name: 'Message Agent' },
                });
                buttonText = this.molang('dpp.hotleadForm.go');
            } else if (buttonText == this.molang('dpp.hotButton.requestTour')) {
                const testRequestTour = this.dpp.isActive;
                const timePickerSplit = this.getSplit('movoto-request-tour-CW-4531', 'on');
                this.$eventBus.$emit('property-pop-schedule', {
                    date: testRequestTour ? undefined : new Date(),
                    hotleadType: isFloating ? 'TourAsPrimaryCTA_Floating' : 'TourAsPrimaryCTA',
                    changeDate: true,
                    optionalDate: testRequestTour ? true : false,
                    hideProfile: testRequestTour,
                    showAddressAndImage: testRequestTour,
                    hotleadTitle: testRequestTour ? this.molang('dpp.hotButton.requestTour') : this.molang('dpp.propertyChat.scheduleTour'),
                    hotleadSub: testRequestTour ? this.molang('dpp.propertySchedule.seeThisHome') : '',
                    trigger: testRequestTour ? 'propertyTour' : this.$options.name,
                    buttonText: testRequestTour ? this.molang('dpp.hotleadForm.submit') : 'Request Appointment',
                    showTourTimePicker: timePickerSplit,
                });
                this.$eventBus.$emit('ga', { ec: 'dppHotleadButton', en: 'click_custom', el: 'Request_Tour', props: { link_name: 'Request Tour' } });
                return;
            } else {
                if (this.showBuyerAgentCTA()) {
                    hotleadTitle = this.molang('dpp.hotleadForm.connectBuyerAgent');
                }
            }
            let btnText = this.showBuyerAgentCTA() ? this.molang('dpp.hotleadForm.go') : buttonText || this.molang('dpp.hotButton.requestInfo');

            this.$eventBus.$emit('dialog-center', {
                name: 'mvtHotleadForm',
                trigger: this.$options.name,
                opt: {
                    hotleadTitle: hotleadTitle,
                    hotleadSub: hotleadSub || subCopy || undefined,
                    hotleadType: hotleadType,
                    propertyId: this.dpp.propertyId,
                    propertyData: this.dpp,
                    agentData: listingAgentData,
                    buttonText: btnText,
                    showComment: showCommentBox,
                    hideProfile: hideProfile,
                    showBuySold: true,
                },
            });
        },
        openAssignedAgentHotlead(buttonText) {
            //set diff hotleadtype when the css force the hotlead floating
            const body = window?.document?.getElementById('body');
            let isFloating = false;
            if (body && body.classList && body.classList.contains('scrollDown') && !body.classList.contains('overlay-active') && body.clientWidth < 992) {
                isFloating = true;
            }
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtHotleadForm',
                trigger: this.$options.name,
                opt: {
                    hotleadTitle: this.newSoldPublicRecordCta ? 'Schedule a selling consultation' : '',
                    hotleadType: this.newSoldPublicRecordCta ? 'RequestSellingConsultation_SoldPRDPP' : isFloating ? 'PrimaryMessageAgent_Floating' : 'GoSeeThisHomeHotleadInResponsiveDPP',
                    propertyId: this.dpp.propertyId,
                    propertyData: this.dpp,
                    buttonText: buttonText || 'Request Info',
                    showComment: false,
                    agentData: this.glb.agent,
                    ojoFormConfigs: {
                        showCtaLinks: true,
                        showOJOagentInfo: true,
                        showDisclaimer: false,
                        commnetLabel: 'Message',
                    },
                },
            });
        },
        openAgentSelection() {
            this.$eventBus.$emit('dialog-center', { name: 'changeAgent', trigger: this.$options.name, opt: {} });
        },
    },
};
